import { render } from "./FaceList.vue?vue&type=template&id=20bff922&scoped=true&ts=true"
import script from "./FaceList.vue?vue&type=script&lang=ts"
export * from "./FaceList.vue?vue&type=script&lang=ts"

import "./FaceList.vue?vue&type=style&index=0&id=20bff922&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bff922"]])

export default __exports__